export const childSimpleDailyGroupAttendanceDTOFields = {
    date: 'date',
    type: 'type',
    entryTime: 'entryTime',
    exitTime: 'exitTime',
    deletable: 'deletable',
} as const;
